import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// import './CourseTable.css'; // Optional: For custom styles if needed
import plus_icon from "../../../assets/dashboard/plus-icon.svg"
import { downloadSalesByTrainer, getAllCourses } from '../../../services/Trainer/trainer';
import moment from 'moment';
import { toast } from 'react-toastify';
import './styles.css'
const PolicyTable = ({ courses, onDeleteCourse, onAssignStaff }) => {
  
    const navigate = useNavigate();
 const [downloading , setDownloading] = useState(false)

    const onEdit = (id,isApproved) =>{
         if(isApproved){
            toast.error("You cannot make changes to this Policy because it has been verified.")
            }
            else{
     navigate(`edit-sales/${id}`);

            }
    }
    
const downloadFile = async () => {
    setDownloading(true)
  try {
    const rawCsv = await downloadSalesByTrainer(); 

    if (!rawCsv || typeof rawCsv !== "string" || rawCsv?.data?.length == 0) {
             toast.error(rawCsv?.message || "There is no data found")
             setDownloading(false)
             return;
           }

    // Split lines
    const lines = rawCsv.trim().split("\n");

    // Extract headers from the first line
    const headers = lines[0].split(",");

    // Convert each line to an object
    const data = lines.slice(1).map(line => {
      const values = line.split(",");
      const obj = {};
      headers.forEach((header, index) => {
        obj[header.trim()] = values[index]?.trim() ?? "";
      });
      return obj;
    });

    // Confirm parsed data
    console.log("Parsed CSV Data:", data);

    // Generate downloadable CSV again (in case you want to filter or just force the download)
    const csvRows = [
      headers.join(","),
      ...data.map(row =>
        headers.map(field => `"${(row[field] ?? "").replace(/"/g, '""')}"`).join(",")
      ),
    ];

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "sales_export.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setDownloading(false)
    toast.success("File download Successfully!");

  } catch (error) {
    setDownloading(false)
    console.error("Download failed:", error);
    toast.error("Something went wrong while downloading the CSV.");
  }
};
    return (
        <div className="management-container">
            <div className="management-header">
                <h2>Sales Management</h2>
                <div className="button-group">
                   <button className="export-btn" onClick={()=>downloadFile()}
                        disabled={downloading}
                        >
                            {downloading ? 
                             "loading...."
                        :
                        <>
                        <i className="bi bi-file-earmark-arrow-down me-2"></i> Export
                        </>
                        }
                        
                    </button>
                    <Link to="add-sales">
                        <button className="add-btn">
                            + Add Sales
                        </button>
                    </Link>
                </div>
            </div>

            <div className="table-container">
                <table className="course-table">
                    <thead>
                        <tr>
                            <th colSpan="5">
                                <div className="sales-table-header table-header ">
                                    <div className="cell">Sr #</div>
                                     <div className="cell">Staff Name</div>
                                     <div className="cell">Product Sales</div>
                                    <div className="cell">Package Sale</div>
                                    <div className="cell">Re-booking Rate</div>
                                    <div className="cell">Dates</div>
                                    <div className="cell">Action</div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            courses && courses?.length > 0 ?
                                <>
                                 {courses && courses.map((course,index) => (
                            <tr key={course._id}>
                                <td colSpan="5">
                                    <div className="sales-table-row table-row">
                                        <div className="cell">{index+1}</div>
                                       <div className="cell">{course?.staff?.fullName}</div>
                                       <div className="cell">{course.productSold}</div>
                                        <div className="cell viewed">{course.membershipSold}</div>
                                        <div className="cell viewed">{course.rebooked}</div>
                                        <div className="cell">{moment(course?.createdAt).format("DD-MM-YYYY")}</div>
                                        <div className="cell action">
                                            <button className="action-button" data-bs-toggle="dropdown">
                                                <i className="bi bi-three-dots"></i>
                                            </button>
                                            <div className="dropdown-menu">
                                                <button
                                                    className="delete-btn d-flex justify-content-between align-items-center w-100"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        onDeleteCourse(course._id);
                                                    }}
                                                >
                                                    <span className="text-danger">Delete</span>
                                                    <span className="icon-circle bg-danger-subtle text-danger ms-2">
                                                        <i className="bi bi-trash-fill"></i>
                                                    </span>
                                                </button>

                                                {/* <hr className="my-2" /> */}

                                                {/* <button
                                                    className="assign-btn d-flex justify-content-between align-items-center w-100"
                                                    // onClick={(e) => {
                                                    //     e.stopPropagation();
                                                    //     onAssignStaff(course._id);
                                                    // }}
                                                >
                                                    <span className="text-secondary">Assign Staff</span>
                                                    <img src={plus_icon} alt='plus' width={25} height={25} />
                                                </button> */}
                                                <button
                                                    className="assign-btn d-flex justify-content-between align-items-center w-100"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        onEdit(course._id,course?.isApproved);
                                                    }}
                                                >
                                                    <span className="text-secondary">Edit</span>
                                                    <span className="icon-circle bg-success-subtle text-secondary ms-2">
                                                        <i className="bi bi-pencil-fill"></i>
                                                    </span>
                                                </button>

                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                                </>
                             :
                             <div
                className="col-md-12"
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '200px', // Adjust as needed
                  gap: '8px',
                  fontSize: '18px',
                  color: '#666'
                }}
              >
                <i className="bi bi-info-circle" style={{ fontSize: '20px' }}></i>
                No records found
              </div>
                        }
                       
                    </tbody>
                </table>
            </div>
        </div>

    );
};

export default PolicyTable;
